let getAccessToken = null;
export const sec = {
    getAccessToken: () => getAccessToken,
    setAccessToken: (func) => (getAccessToken = func)
};
